var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#21B55A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4133 31.6L26.4133 33.6L31.7467 28.2667",
    stroke: "#21B55A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 20H30.6667C33.3333 20 33.3333 18.6667 33.3333 17.3334C33.3333 14.6667 32 14.6667 30.6667 14.6667H25.3333C24 14.6667 22.6667 14.6667 22.6667 17.3334C22.6667 20 24 20 25.3333 20Z",
    stroke: "#21B55A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 17.36C37.7733 17.6 40 19.24 40 25.3333V33.3333C40 38.6667 38.6667 41.3333 32 41.3333H24C17.3333 41.3333 16 38.6667 16 33.3333V25.3333C16 19.2533 18.2267 17.6 22.6667 17.36",
    stroke: "#21B55A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconic);
export default __webpack_public_path__ + "static/media/iconic.cf63065abeeb774cc095133b4d66290a.svg";
export { ForwardRef as ReactComponent };